import React, { Fragment, useState, useEffect, useRef } from 'react'

import LoadingIndicatorModal from './loadingIndicatorModal'

const RemoveNonEventActivity = ({
  id,
  agencyId,
  hasResults,
  setEventProgramEvent,
  setInstructorResultDetails,
}) => {
  const [showLoadingModal, setShowLoadingModal] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const submitRemoveNonEventDay = (e) => {
    e.preventDefault()

    if (isDeleting) return

    setShowLoadingModal(true)

    if (hasResults) {
      const confirmed = window.confirm(
        'Are you sure you want to remove this Non-Event Day Activity? ' +
          'This will also delete all associated results.'
      )
      if (!confirmed) return
    }

    destroyActivity()
  }

  const destroyActivity = () => {
    setIsDeleting(true)

    Fetchable.delete(`/events/agencies/${agencyId}/event_activities/${id}`)
      .then((res) => {
        if (res.ok) {
          return res.json()
        } else {
          return res.json().then((errorData) => {
            throw new Error(errorData.error || 'Could not remove Event Activity')
          })
        }
      })
      .then((data) => {
        if (isMountedRef.current) {
          setEventProgramEvent(data.program_event)
          setInstructorResultDetails(data.instructor_result_details)
          setIsDeleting(false)
          setShowLoadingModal(false)
        }
      })
  }

  return (
    <Fragment>
      {showLoadingModal && <LoadingIndicatorModal title="Removing Non-Event Day" />}
      <i
        className={`material-icons u-pull--right m-0 ${isDeleting ? 'u-opacity--50' : ''}`}
        aria-hidden="true"
        style={{
          cursor: isDeleting ? 'not-allowed' : 'pointer',
          color: 'red',
        }}
        onClick={(e) => !isDeleting && submitRemoveNonEventDay(e)}
        title="Delete Non-Event Day">
        delete_forever
      </i>
    </Fragment>
  )
}

export default RemoveNonEventActivity
